import React from 'react'
import { Button } from '@deal/components'
import NotificationDenied1x from './assets/notification-denied.png'
import NotificationDenied2x from './assets/notification-denied@2x.png'
import NotificationDenied3x from './assets/notification-denied@2x.png'
import styles from './styles.css'

interface Props {
  onDissmissPage: () => void
  onAcceptNotifcations: () => void
}

const RequestPushNotificationAfterDenial: React.SFC<Props> = ({
  onDissmissPage,
  onAcceptNotifcations
}) => {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <strong>Oh, no!</strong>
        <div className={styles.copy}>
          If you change your mind and want access to deals faster you can enable Push Notifications
          in settings.
        </div>
        <div className={styles.actionEnable}>
          <Button
            size="large"
            variant="contrast-light"
            type="button"
            className={styles.button}
            onClick={onAcceptNotifcations}
          >
            Allow Push Notifications
          </Button>
        </div>
      </div>
      <div className={styles.imageContainer}>
        <img
          src={NotificationDenied1x}
          alt="Enable Push Notifications"
          className={styles.image}
          srcSet={`${NotificationDenied1x}, ${NotificationDenied2x} 2x, ${NotificationDenied3x} 3x`}
        />
      </div>

      <div className={styles.actionDismiss}>
        <Button size="large" type="button" onClick={onDissmissPage} className={styles.button}>
          Next
        </Button>
      </div>
    </div>
  )
}

export default RequestPushNotificationAfterDenial
